import { createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchClientLabels } from '../../../DisplayClientLabels'
import { IClientLabel } from '../../../../entities/ClientLabel'

export const addNewClientLabel = createAsyncThunk<
	void,
	IClientLabel,
	ThunkConfig<string>>
(
	'addNewClientLabel',
	async (newClientLabel, thunkAPI) => {
		const {
			dispatch,
			extra: { api },
			rejectWithValue
		} = thunkAPI

		const labelColor = newClientLabel.labelColor && newClientLabel.labelColor.length === 7 ?
			newClientLabel.labelColor + 'D9' :
			newClientLabel.labelColor

		const newLabelDTO = { ...newClientLabel, labelColor }

		try {
			await api.post('/clientLabels', newLabelDTO)

			showToast({
				type: 'success',
				toastId: 'addNewClientLabel',
				message: 'New client label added'
			})

			dispatch(fetchClientLabels()) // NOTE: imported neighbor feature
		} catch (e) {
			console.log(e)
			appHandleError(e, 'addNewClientLabel', 'Failed to add a new client label')
			return rejectWithValue('Error occurred while creating a client label')
		}
	}
)
